import React from 'react';

import { Mui } from '../..';

export const Account = props => <Mui.Icon {...props}>business</Mui.Icon>;
